import { OPERATORS } from '../../../../shared/screener-constants';

/**
 * A custom class for creating conditions for screener arguments
 * that allows method-chaining for easier operator management
 */
export default class Conditions {
  constructor() {
    this.conditionList = [];
  }

  equalTo(values) {
    const operator = OPERATORS.EQUALTO;
    this.conditionList.push({ operator, values });
    return this;
  }

  greaterThanEqualTo(values) {
    const operator = OPERATORS.GREATERTHANEQUALTO;
    this.conditionList.push({ operator, values });
    return this;
  }

  greaterThan(values) {
    const operator = OPERATORS.GREATERTHAN;
    this.conditionList.push({ operator, values });
    return this;
  }

  lessThanEqualTo(values) {
    const operator = OPERATORS.LESSTHANEQUALTO;
    this.conditionList.push({ operator, values });
    return this;
  }

  like(values) {
    const operator = OPERATORS.LIKE;
    this.conditionList.push({ operator, values });
    return this;
  }

  lessThan(values) {
    const operator = OPERATORS.LESSTHAN;
    this.conditionList.push({ operator, values });
    return this;
  }

  notEqualTo(values) {
    const operator = OPERATORS.NOTEQUALTO;
    this.conditionList.push({ operator, values });
    return this;
  }

  notLike(values) {
    const operator = OPERATORS.NOTLIKE;
    this.conditionList.push({ operator, values });
    return this;
  }

  sameAs(values) {
    const operator = OPERATORS.SAMEAS;
    this.conditionList.push({ operator, values });
    return this;
  }
}
